import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.pink100};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${(props) => props.theme.fonts.interSemibold10};
  color: ${(props) => props.theme.colors.white100};
  user-select: none;
`;